import { render } from "./AmountInput.vue?vue&type=template&id=03536a2d&scoped=true"
import script from "./AmountInput.vue?vue&type=script&lang=js"
export * from "./AmountInput.vue?vue&type=script&lang=js"

import "./AmountInput.vue?vue&type=style&index=0&id=03536a2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03536a2d"]])

export default __exports__